import { Link } from 'react-router-dom';
import { useLanguage } from '../utils/i18n';
import Logo from '../components/Logo';
import LanguageToggle from '../components/LanguageToggle';

export default function PrivacyPolicy() {
    const { t } = useLanguage();

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
            {/* Navbar */}
            <nav className="navbar">
                <Link to="/" className="navbar-brand">
                    <Logo size={24} />
                    <span>Wafiyo</span>
                </Link>
                <LanguageToggle />
            </nav>

            <div className="container" style={{ maxWidth: 720, paddingTop: 48, paddingBottom: 80 }}>
                <div className="glass-card" style={{ padding: '40px 32px' }}>

                    <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>{t('privacy_policy_title')}</h1>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 32 }}>{t('legal_last_updated')}: 26/02/2026</p>

                    <div className="legal-content">
                        <section>
                            <h2>{t('pp_intro_title')}</h2>
                            <p>{t('pp_intro_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_data_collected_title')}</h2>
                            <p>{t('pp_data_collected_text')}</p>
                            <ul>
                                <li>{t('pp_data_item_name')}</li>
                                <li>{t('pp_data_item_email')}</li>
                                <li>{t('pp_data_item_phone')}</li>
                                <li>{t('pp_data_item_visits')}</li>
                                <li>{t('pp_data_item_payment')}</li>
                            </ul>
                        </section>

                        <section>
                            <h2>{t('pp_how_we_use_title')}</h2>
                            <p>{t('pp_how_we_use_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_data_protection_title')}</h2>
                            <p>{t('pp_data_protection_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_third_parties_title')}</h2>
                            <p>{t('pp_third_parties_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_cookies_title')}</h2>
                            <p>{t('pp_cookies_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_data_retention_title')}</h2>
                            <p>{t('pp_data_retention_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_user_rights_title')}</h2>
                            <p>{t('pp_user_rights_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_international_title')}</h2>
                            <p>{t('pp_international_text')}</p>
                        </section>

                        <section>
                            <h2>{t('pp_contact_title')}</h2>
                            <p>{t('pp_contact_text')}</p>
                        </section>
                    </div>

                    <div style={{ marginTop: 32, textAlign: 'center' }}>
                        <Link to="/" className="btn btn-outline btn-sm glass-btn">{t('back_to_home')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
